import { Button } from "devextreme-react";
import { useEffect, useState } from "react";

import "../index.css";

export default function ScrollToTopButtonComponent(props) {
  const [isVisible, setIsVisible] = useState(false);

  // 스크롤 이벤트 핸들러
  const handleScroll = () => {
    if (window.scrollY > 300) {
      // 특정 스크롤 위치를 넘으면 버튼을 보이게 함
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // 페이지 로드시 및 업데이트 시 스크롤 이벤트 리스너 등록/제거
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // 클릭 시 최상단으로 스크롤하는 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // 부드러운 스크롤 효과 적용
    });
  };

  if (!isVisible) {
    return null; // 스크롤 위치가 낮으면 버튼을 숨김
  }

  return (
    <Button
      id="scrollToTopButtonComponent"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        // borderRadius: "5px",
        borderRadius: "50%",
        // padding: "10px 15px",
        padding: 0,
        cursor: "pointer",
        // fontSize: "16px",
        opacity: 0.8,
        transition: "opacity 0.3s ease-in-out",
        zIndex: 1000, // 다른 요소 위에 표시
        width: "30px",
        height: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
      }}
      onClick={scrollToTop}
      icon="fa-solid fa-arrow-up"
      onMouseEnter={(e) => (e.target.style.opacity = 1)}
      onMouseLeave={(e) => (e.target.style.opacity = 0.8)}
    ></Button>
  );
}
